<template>
  <div>
    <template v-if="isEditTagMode">
      <v-text-field
        outlined
        class="mt-3"
        dense
        counter
        maxlength="15"
        :label="$t(`variables.${equipmentProfile.variables[index].code}`)"
        v-model="tagName"
      ></v-text-field>
      <v-btn @click="saveTagNameValidation">Guardar</v-btn>
    </template>
    <template v-else>
      <v-icon @click="isEditTagMode = true" dense>mdi-pencil</v-icon>
      {{
        equipmentProfile.variables[index].tagName ||
          tagName ||
          $t(`variables.${equipmentProfile.variables[index].code}`)
      }}
      <span
        v-if="equipmentProfile.variables[index].tagName"
        class="text-caption"
      >
        {{ $t(`variables.${equipmentProfile.variables[index].code}`) }}
      </span>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex"; /* 
import { db } from "@/plugins/db"; */

export default {
  name: "EditVariableTag",
  props: ["index", "variable"],
  computed: {
    ...mapState("equipments", ["equipmentProfile"])
  },
  data() {
    return {
      isEditTagMode: false,
      tagName: ""
    };
  },
  created() {
    this.tagName = this.equipmentProfile?.variables[this.index]?.tagName
      ? this.equipmentProfile.variables[this.index].tagName
      : "";
  },
  methods: {
    saveTagNameValidation: async function() {
      this.isEditTagMode = false;
      await this.saveTagName();
    },
    saveTagName: async function() {
      this.equipmentProfile.variables[this.index].tagName = this.tagName;
      this.$emit("save-tag");
      /* try {

        await db
          .collection("equipments")
          .doc(this.equipmentProfile.id)
          .update({
            variables: this.equipmentProfile.variables
          });
        /*
        this.$dialog.notify.success("Tag Name was updated successfuly", {
          position: "top-right",
          timeout: 5000
        }); 
      } catch (error) {
        this.$dialog.notify.error(error, {
          position: "top-right",
          timeout: 5000
        });
      } */
    }
  }
};
</script>

<style scoped>
.text-caption {
  opacity: 0.4;
}
</style>
